const productModal = () => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('productModal', () => ({
      open: false,
      overlayOpen(e) {
        if (e.detail.overlay !== 'productModal') {
          this.closeModal();
        }
      },
      closeModal() {
        this.open = false;
        this.$dispatch('overlay:close', { overlay: 'productModal' });
      },
      async toggleModal(event) {
        const targetData = event.detail.target;

        await getProductData(targetData);

        this.open = !this.open;

        if (this.open) {
          this.$dispatch('overlay:open', { overlay: 'productModal' });
        } else {
          this.$dispatch('overlay:close', { overlay: 'productModal' });
        }
      },
    }));
  });
};
export default productModal;
async function getProductData(handle) {
  const localUrl = `/products/${handle}?section_id=sections--24608478265721__product_modal_yFW8Ba`;
  const mainUrl = `/products/${handle}?section_id=sections--17069504004267__product_modal_yFW8Ba`;
  const devUrl = `/products/${handle}?section_id=sections--17144026431659__product_modal_yFW8Ba`;
  let response;

  try {
    response = await fetch(mainUrl);
    if (!response.ok) {
      throw new Error('Local fetch failed');
    }
  } catch (error) {
    console.warn('Failed to fetch from local URL, trying main URL:', error);
    try {
      response = await fetch(devUrl);
      if (!response.ok) {
        throw new Error('Main fetch failed');
      }
    } catch (error) {
      console.error('Failed to fetch from both development and main URLs:', error);
      try {
        response = await fetch(localUrl);
        if (!response.ok) {
          throw new Error('Main fetch failed');
        }
      } catch (error) {
        console.error('Failed to fetch from local, development and main URLs:', error);
        // Handle the error as appropriate, e.g., show a user-friendly message
        return null;
      }
    }
  }

  let productMarkup = await response.text();
  let parser = new DOMParser();
  let doc = parser.parseFromString(productMarkup, 'text/html');

  let contentDiv = doc.querySelector('.content');

  const replacingHTML = document.querySelector('#modal-section');
  replacingHTML.innerHTML = contentDiv.outerHTML;

  const modalParent = document.querySelector('.modal-parent');

  reinitializeReviews();
  getAddToCartForm(handle);
}

function getAddToCartForm(handle) {
  const initialPercentageSelect = document.querySelector('#sellingPlanPickerSelect');
  if (initialPercentageSelect) {
    const initialOption = initialPercentageSelect.selectedOptions[0] ?? null;
    if (initialOption) {
      initialPercentage = initialOption.dataset.percentage ?? 0;
      initialAmount = initialOption.dataset.amount ?? 0;
      isCartButtonActive = false;
    } else {
      initialPercentage = 0;
      initialAmount = 0;
      isCartButtonActive = true;
    }
  } else {
    initialPercentage = 0;
    initialAmount = 0;
    isCartButtonActive = true;
  }

  Alpine.data('modalOptions', window.productOptions);
}

function reinitializeReviews() {
  const reviewSnippets = document.querySelectorAll('.ruk_rating_snippet');

  reviewSnippets.forEach((snippet) => {
    const dataSku = snippet.getAttribute('data-sku');
    ratingSnippet('ruk_rating_snippet', {
      store: 'highernature.com',
      mode: 'default',
      color: '#988075',
      linebreak: false,
      text: 'Reviews',
      singularText: 'Review',
      lang: 'en',
      usePolaris: true,
      showEmptyStars: true,
    });
  });
}
